import { Quantity } from './quantity';

export function assertString(v: unknown): string {
  if (typeof v !== 'string') {
    throw new Error(
      `internal type error: expected string, got ${v} (${typeof v})`
    );
  }
  return v;
}

export function assertNumber(v: unknown): number {
  if (typeof v === 'number') {
    return v;
  } else if (v instanceof Quantity) {
    throw new Error(
      `internal type error: expected number, got Quantity(${v.value})`
    );
  } else {
    throw new Error(
      `internal type error: expected number, got ${v} (${typeof v})`
    );
  }
}

export function assertComparable(v: unknown): string | number | null {
  if (typeof v !== 'number' && typeof v !== 'string' && v !== null) {
    throw new Error(
      `internal type error: expected comparable (number or string), got ${typeof v}`
    );
  }
  return v;
}

export function assertConstantValue(v: unknown): number | string | boolean {
  if (
    typeof v !== 'number' &&
    typeof v !== 'string' &&
    typeof v !== 'boolean'
  ) {
    throw new Error(
      `internal type error: expected number | string | boolean, got ${v} (${typeof v})`
    );
  }
  return v;
}

export function debugAssert(
  trueFact: boolean,
  msg: () => string
): asserts trueFact {
  if (!trueFact) {
    throw new Error(`internal error: ${msg()}`);
  }
}
